import { Injectable } from "@angular/core";

/**
 * Limits concurrent image loads to avoid browser connection saturation.
 */
@Injectable({ providedIn: "root" })
export class LazyLoadQueueService {
  private static readonly MAX_CONCURRENT = 6;

  private active = 0;
  private queue: Array<() => void> = [];

  /** Returns a promise that resolves when a load slot is available */
  acquire(): Promise<void> {
    if (this.active < LazyLoadQueueService.MAX_CONCURRENT) {
      this.active++;
      return Promise.resolve();
    }
    return new Promise(resolve => {
      this.queue.push(() => {
        this.active++;
        resolve();
      });
    });
  }

  /** Release slot when image load completes (success or error) */
  release(): void {
    this.active = Math.max(0, this.active - 1);
    if (this.queue.length > 0) {
      const next = this.queue.shift();
      if (next) next();
    }
  }
}
